<template>
  <div>
    <div class="ui form">
      <h3 class="ui dividing header">Выбор учебного плана</h3>
      <div class="three fields">
        <div class="nine wide field">
          <label>Специальность</label>
          <select @change="getEduProf(rpp.edu_prog)"
                  class="ui fluid search selection dropdown fullText"
                  name="edu_prog"
                  v-model="rpp.edu_prog">
            <option value="">Выберите специальность</option>
            <option v-for="option in select_options.edu_progs" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="three wide field">
          <label>Год</label>
          <select @change="getCurriculum(rpp.edu_prog, rpp.year, rpp.edu_prof)"
                  class="ui fluid search selection dropdown"
                  name="year"
                  v-model="rpp.year">
            <option value="">Год учебного плана</option>
            <option v-for="option in select_options.years" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="nine wide field">
          <label>Профиль</label>
          <select @change="getCurriculum(rpp.edu_prog, rpp.year, rpp.edu_prof)"
                  id="edu_prof" class="ui fluid search selection dropdown"
                  name="edu_prof"
                  v-model="rpp.edu_prof">
            <option value="">Выберите профиль</option>
            <option v-for="option in select_options.edu_profs" :value="option.id" :key="option.id">
              {{ option.id1c }} {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <div class="three fields">
          <div class="twelve wide field">
            <label class="bold">Учебный план</label>
            <select id="curriculum"
                    @change="getDisciplines(rpp.curriculum)"
                    class="ui fluid search selection dropdown"
                    name="curriculum"
                    v-model="rpp.curriculum">
              <option value="">Учебный план</option>
              <option v-for="option in select_options.curriculum" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="six wide field">
            <label class="bold">Дисциплина</label>
            <select id="discipline"
                    @change="getMainInformation(rpp.edu_prog, rpp.edu_prof, rpp.curriculum, rpp.discipline)"
                    class="ui fluid search selection dropdown fullText"
                    name="discipline"
                    v-model="rpp.discipline">
              <option value="">Дисциплина</option>
              <option v-for="option in select_options.disciplines" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="main_info.speciality_code.split('.')[1] === '02'">
        <div class="four wide field">
          <label class="bold">Индекс дисциплины</label>
          <input type="text" placeholder="Индекс" v-model="main_info.disciplines_index">
        </div>
      </div>
    </div>
    <h3 class="ui dividing header">Использовать в качестве шаблона</h3>
    <div class="nine wide field">
      <label style="font-weight: bold">Заполнить на основании шаблона</label>
      <select @change="getRPP(rpp.rpp_sample)"
              class="ui fluid search selection dropdown fullText"
              name="edu_prog"
              v-model="rpp.rpp_sample">
        <option value="0">Без шаблона</option>
        <option v-for="option in select_options.rpp_samples" :value="option.id" :key="option.id">
          {{ option.name }}, Профиль: {{ option.profile}}
        </option>
      </select>
    </div>
    <div class="ui form" id="main" v-if="main">
      <h3 class="ui dividing header">Основная информация</h3>
      <div class="inline fields">
        <div class="five wide field">
          <div class="ui right pointing large label">
            РАБОЧАЯ ПРОГРАММА
          </div>
          <input type="text" placeholder="Дисциплина" v-model="main_info.discipline" disabled="true">
        </div>
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
          <div class="ui right pointing large label">
            Направление подготовки
          </div>
          <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
        </div>
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
          <div class="ui right pointing large label">
            Специальность
          </div>
          <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
        </div>
        <div class="four wide field">
          <div class="ui right pointing large label">
            Квалификация выпускника
          </div>
          <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
        </div>
      </div>
      <div class="inline fields">
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
          <div class="ui right pointing large label">
            Профиль
          </div>
          <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
        </div>
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
          <div class="ui right pointing large label">
            Специализация
          </div>
          <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
        </div>
        <div class="two wide field">
          <div class="ui right pointing large label">
            Год набора
          </div>
          <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            Форма обучения
          </div>
          <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
        </div>
      </div>
      <div class="ui equal width form">
        <div class="inline fields">
          <div class="three wide field">
            <div class="ui right pointing large label">
              Курс
            </div>
            <input type="text" placeholder="Курс" v-model="main_info.course" disabled="true">
          </div>
          <div class="three wide field" v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
            <div class="ui right pointing large label">
              Семестр
            </div>
            <input type="text" placeholder="Семестр" v-model="main_info.period" disabled="true">
          </div>
          <div class="three wide field" v-if="main_info.credit_mark.length">
            <div class="ui right pointing large label">
              Зачет с оценкой
            </div>
            <input type="text" placeholder="Зачет" v-model="main_info.credit_mark" disabled="true">
          </div>
          <div class="three wide field">
            <div class="ui right pointing large label">
              Трудоемкость
            </div>
            <input type="text" placeholder="Трудоемкость" v-model="main_info.load.hour" disabled="true">
          </div>
          <div class="three wide field">
            <div class="ui right pointing large label">
              ЗЕТ
            </div>
            <input type="text" placeholder="ЗЕТ" v-model="main_info.load.zet" disabled="true">
          </div>
        </div>
        <div class="inline fields">
          <div class="four wide field">
            <div class="ui right pointing large label">
              И.О.Фамилия
            </div>
            <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Должность
            </div>
            <input type="text" placeholder="Должность" v-model="main_info.creator.position">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Ученая степень
            </div>
            <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title">
          </div>
        </div>
      </div>
      <table class="ui red celled table">
        <thead>
        <tr class="active">
          <th>Семестр</th>
          <th>Нагрузка</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for = "load in TotalLoad">
          <td width="70%" >{{ load.key }}</td>
          <td>
            <div class="ui list" v-for = "type in load.value">
              <div class="item">{{type.load}} - {{type.value}}</div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="two fields">
        <div class="six wide field">
          <label>Выпускающая кафедра</label>
          <select class="ui fluid search selection dropdown"
                  name="grad_dep"
                  v-model="main_info.grad_dep">
            <option value="">Выпускающая кафедра</option>
            <option v-for="option in select_options.departments" :value="option.name" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="six wide field">
          <label>Заведующий выпускающей кафедры</label>
          <div class="ui input">
            <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="provisor">
          </div>
        </div>
      </div>
      <div class="three fields">
        <div class="five wide field">
          <label>Факультет</label>
          <div class="ui input">
            <input type="text" placeholder="Факультет" v-model="main_info.facility">
          </div>
        </div>
        <div class="five wide field">
          <label>Обеспечивающая кафедра</label>
          <div class="ui input">
            <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department">
          </div>
        </div>
        <div class="five wide field">
          <label>
            Заведующий кафедрой
          </label>
          <div class="ui input">
            <input type="text" placeholder="Заведующий кафедрой" v-model="main_info.dep_manager">
          </div>
        </div>
      </div>
      <div class="two fields">
        <div class="four wide field">
          <label>Дата заседания кафедры</label>
          <div class="ui input">
            <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date">
          </div>
        </div>
        <div class="two wide field">
          <label>Протокол №</label>
          <div class="ui input">
            <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num">
          </div>
        </div>
      </div>
      <div><textarea rows="2" v-model="main_info.basis"></textarea></div>
      <div class="two fields">
        <div class="four wide field">
          <label>Дата утверждения приказа</label>
          <div class="ui input">
            <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date">
          </div>
        </div>
        <div class="two wide field">
          <label>№ Приказа</label>
          <div class="ui input">
            <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num">
          </div>
        </div>
      </div>
      <div v-if="main_info.speciality_code.split('.')[1] === '02'">
        <h2 class="ui dividing header">Пояснительная записка</h2>
        <h3 class="ui dividing header">ТИПЫ ПРАКТИКИ</h3>
        <div class="ui form"><textarea rows="2" type="text" placeholder="Тип (форма проведения) практики" v-model="practice_type.type"></textarea></div>
        <h3 class="ui dividing header">ПЛАНИРУЕМЫЕ РЕЗУЛЬТАТЫ ОСВОЕНИЯ</h3>
        <h4>При прохождении практики у обучающегося должны быть сформированны компетенции</h4>
        <h4>Общие компетенции</h4>
        <table class="ui basic celled table">
          <thead>
          <tr class="active">
            <th width="20%"><div class="headTable">Код</div></th>
            <th width="30%"><div class="headTable">Наименование общих компетенции</div></th>
            <th width="50%" colspan="2"><div class="headTable">Наименование индикатора достижения общей компетенции</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "comp in rpp_competitions.UK">
            <td>
              <select id="UKcompetition" class="ui fluid search selection dropdown"
                      name="UKcompetition"
                      v-model="comp.info">
                <option value="">Выберите компетенцию</option>
                <option v-for="option in UK" :value="option" :key="option.id">
                  {{ option.code }} {{ option.desc }}
                </option>
              </select>
            </td>
            <td>
              {{ comp.info.desc }}
            </td>
            <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
            <td width="2%">
              <button class="ui icon button red stub" v-on:click="DelUKCompetition(rpp_competitions.UK.indexOf(comp))"><i class="trash icon"></i></button>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="4">
              <button class="ui right floated small button positive" v-on:click="AddUKCompetition">
                <i class="add icon"></i>
                Добавить компетенцию
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <h4>Професиональные компетенции и индикаторы их достижения</h4>
        <table class="ui basic celled table" v-if="OPK.length">
          <thead>
          <tr class="active">
            <th width="20%"><div class="headTable">Код</div></th>
            <th width="30%"><div class="headTable">Наименование профессиональной компетенции</div></th>
            <th width="50%" colspan="2"><div class="headTable">Наименование индикатора достижения профессиональной компетенции</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "comp in rpp_competitions.OPK_cat">
            <td>
              <select id="OPKCatcompetition" class="ui fluid search selection dropdown"
                      name="OPKCatcompetition"
                      v-model="comp.info">
                <option value="">Выберите компетенцию</option>
                <option v-for="option in OPK" :value="option" :key="option.id">
                  {{ option.code }} {{ option.desc }}
                </option>
              </select>
            </td>
            <td>{{ comp.info.desc }}</td>
            <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
            <td width="2%">
              <button class="ui icon button red stub" v-on:click="DelOPKCatCompetition(rpp_competitions.OPK_cat.indexOf(comp))"><i class="trash icon"></i></button>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="4">
              <button class="ui right floated small button positive" v-on:click="AddOPKCatCompetition">
                <i class="add icon"></i>
                Добавить компетенцию
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <table class="ui basic celled table" v-if="!OPK.length">
          <thead>
          <tr class="active">
            <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
            <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "comp in rpp_competitions.OPK">
            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование общепрофессиональной компетенции" v-model="comp.name"></textarea></div></td>
            <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
            <td width="2%">
              <button class="ui icon button red stub" v-on:click="DelOPKCompetition(rpp_competitions.OPK.indexOf(comp))"><i class="trash icon"></i></button>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="3">
              <button class="ui right floated small button positive" v-on:click="AddOPKCompetition">
                <i class="add icon"></i>
                Добавить компетенцию
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <h5 class="ui dividing header">Уметь </h5>
        <vue-editor v-model="rpp_competitions.able" :editor-toolbar="customToolbar"/>
        <h5 class="ui dividing header">Знать </h5>
        <vue-editor v-model="rpp_competitions.know" :editor-toolbar="customToolbar"/>
        <h5 class="ui dividing header">Иметь практическое применение </h5>
        <vue-editor v-model="rpp_competitions.own" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">МЕСТО ПРАКТИКИ В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ </h3>
        <vue-editor v-model="text_info.place" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">МЕСТО И ВРЕМЯ ПРОВЕДЕНИЯ  ПРАКТИКИ </h3>
        <vue-editor v-model="text_info.time" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">ОБЪЕМ ПРАКТИКИ В ЗАЧЕТНЫХ ЕДИНИЦАХ И ЕЕ ПРОДОЛЖИТЕЛЬНОСТЬ В НЕДЕЛЯХ</h3>
        <vue-editor v-model="text_info.size" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">СТРУКТУРА И СОДЕРЖАНИЕ ПРАКТИКИ</h3>
        <table class="ui basic celled table">
          <thead>
          <tr class="active">
            <th width="5%"><div class="headTable">№ п/п</div></th>
            <th width="30%"><div class="headTable">Разделы (этапы) практики </div></th>
            <th width="50%"><div class="headTable">Виды работ</div></th>
            <th width="5%" colspan="2"><div class="headTable">Трудоемкость (в академических часах)</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "work in structure">
            <td>{{structure.indexOf(work) + 1}}</td>
            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.part"></textarea></div></td>
            <td><vue-editor v-model="work.content" :editor-toolbar="customContentToolbar"/></td>
            <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Часов" v-model="work.time"></div></td>
            <td width="2%">
              <button class="ui icon button red stub" v-on:click="DelStructure(structure.indexOf(work))"><i class="trash icon"></i></button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">Итого</td>
            <td colspan="2">{{needTime}} ({{main_info.load.hour}})</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="5">
              <button class="ui right floated small button positive" v-on:click="AddStructure">
                <i class="add icon"></i>
                Добавить раздел
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <h3 class="ui dividing header">ОБРАЗОВАТЕЛЬНЫЕ, НАУЧНО-ИССЛЕДОВАТЕЛЬСКИЕ И НАУЧНО-ПРОИЗВОДСТВЕННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ НА ПРАКТИКЕ</h3>
        <vue-editor v-model="text_info.technology" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">ФОРМА ОТЧЕТНОСТИ ПО ПРАКТИКЕ</h3>
        <vue-editor v-model="text_info.report_text" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОВЕДЕНИЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ ПО ПРАКТИКЕ</h3>
        <vue-editor v-model="text_info.eval_tool" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">УЧЕБНО-МЕТОДИЧЕСКИЕ МАТЕРИАЛЫ ПО ПРАКТИКЕ</h3>
        <div>
          <h4>Литература</h4>
          <vue-editor v-model="text_info.literature" :editor-toolbar="customToolbar"/>
          <h4>Программное обеспечение</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                <select id="software" class="ui fluid search selection dropdown"
                        name="software"
                        v-model="soft.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in select_options.software" :value="option" :key="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ soft.info.name }}
                </div>
              </td>
              <td>
                {{ soft.info.license }}
              </td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelSoftware(software.indexOf(soft))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddSoftware">
                  <i class="add icon"></i>
                  Добавить программное обеспечение
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>Интернет ресурсы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "res in resources">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="res.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="res.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelResources(resources.indexOf(res))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddResources">
                  <i class="add icon"></i>
                  Добавить Интернет ресурс
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>Профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="db.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="db.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDataBases(data_bases.indexOf(db))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDataBases">
                  <i class="add icon"></i>
                  Добавить справочную систему
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
        <h3 class="ui dividing header">ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ ДЛЯ ПРОВЕДЕНИЯ  ПРАКТИКИ</h3>
        <vue-editor v-model="text_info.inform_tech" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ  ПРАКТИКИ </h3>
        <vue-editor v-model="text_info.mto" :editor-toolbar="customToolbar"/>
      </div>
      <div v-else>
        <h3 class="ui dividing header">1. ТИП ПРАКТИКИ И СПОСОБ ПРОВЕДЕНИЯ</h3>
        <div>
          <h4>1.1 Тип (форма проведения) практики</h4>
          <div class="ui form"><textarea rows="2" type="text" placeholder="Тип (форма проведения) практики" v-model="practice_type.type"></textarea></div>
          <h4>1.2 Способы проведения практики</h4>
          <div class="ui form"><textarea rows="2" type="text" placeholder="Способы проведения практики" v-model="practice_type.method"></textarea></div>
        </div>
        <h3 class="ui dividing header">2. ЦЕЛИ  И ЗАДАЧИ  ПРАКТИКИ</h3>
        <vue-editor v-model="text_info.purpose" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">3. КОМПЕТЕНЦИИ ОБУЧАЮЩЕГОСЯ, ФОРМИРУЕМЫЕ В РЕЗУЛЬТАТЕ ОСВОЕНИЯ ДИСЦИПЛИНЫ (МОДУЛЯ) И ИНДИКАТОРЫ ИХ ДОСТИЖЕНИЯ</h3>
        <div v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
          <h4>3.1 Универсальные компетенции и индикаторы их достижения</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
              <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
              <th width="40%" colspan="2"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpp_competitions.UK">
              <td>{{comp.info.cat}}</td>
              <td>
                <select id="UKcompetition" class="ui fluid search selection dropdown"
                        name="UKcompetition"
                        v-model="comp.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in UK" :value="option" :key="option.id">
                    {{ option.code }} {{ option.desc }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ comp.info.code }} {{ comp.info.desc }}
                </div>
              </td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelUKCompetition(rpp_competitions.UK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="4">
                <button class="ui right floated small button positive" v-on:click="AddUKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.2 Общепрофессиональные компетенции и индикаторы их достижения</h4>
          <table class="ui basic celled table" v-if="OPK.length">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
              <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
              <th width="40%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpp_competitions.OPK_cat">
              <td>{{comp.info.cat}}</td>
              <td>
                <select id="OPKCatcompetition" class="ui fluid search selection dropdown"
                        name="OPKCatcompetition"
                        v-model="comp.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in OPK" :value="option" :key="option.id">
                    {{ option.code }} {{ option.desc }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ comp.info.code }} {{ comp.info.desc }}
                </div>
              </td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelOPKCatCompetition(rpp_competitions.OPK_cat.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="4">
                <button class="ui right floated small button positive" v-on:click="AddOPKCatCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <table class="ui basic celled table" v-if="!OPK.length">
            <thead>
            <tr class="active">
              <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
              <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpp_competitions.OPK">
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование общепрофессиональной компетенции" v-model="comp.name"></textarea></div></td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelOPKCompetition(rpp_competitions.OPK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddOPKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
              <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpp_competitions.PK">
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование профессиональной компетенции" v-model="comp.name"></textarea></div></td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelPKCompetition(rpp_competitions.PK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddPKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.4 Дополнительные профессиональные компетенции</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
              <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "comp in rpp_competitions.DPK">
              <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование дополнительной профессиональной компетенции" v-model="comp.name"></textarea></div></td>
              <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDPKCompetition(rpp_competitions.DPK.indexOf(comp))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDPKCompetition">
                  <i class="add icon"></i>
                  Добавить компетенцию
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
        <div v-else>
          <h5 class="ui dividing header">Уметь </h5>
          <vue-editor v-model="rpp_competitions.able" :editor-toolbar="customToolbar"/>
          <h5 class="ui dividing header">Знать </h5>
          <vue-editor v-model="rpp_competitions.know" :editor-toolbar="customToolbar"/>
          <h5 class="ui dividing header">Владеть </h5>
          <vue-editor v-model="rpp_competitions.own" :editor-toolbar="customToolbar"/>
        </div>
        <h3 class="ui dividing header">4. МЕСТО ПРАКТИКИ В СТРУКТУРЕ ОБРАЗОВАТЕЛЬНОЙ ПРОГРАММЫ </h3>
        <vue-editor v-model="text_info.place" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">5. МЕСТО И ВРЕМЯ ПРОВЕДЕНИЯ  ПРАКТИКИ </h3>
        <vue-editor v-model="text_info.time" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">6. ОБЪЕМ ПРАКТИКИ В ЗАЧЕТНЫХ ЕДИНИЦАХ И ЕЕ ПРОДОЛЖИТЕЛЬНОСТЬ В НЕДЕЛЯХ</h3>
        <vue-editor v-model="text_info.size" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">7. СТРУКТУРА И СОДЕРЖАНИЕ ПРАКТИКИ</h3>
        <table class="ui basic celled table">
          <thead>
          <tr class="active">
            <th width="5%"><div class="headTable">№ п/п</div></th>
            <th width="30%"><div class="headTable">Разделы (этапы) практики </div></th>
            <th width="50%"><div class="headTable">Содержание раздела (этапа) практики</div></th>
            <th width="5%" colspan="2"><div class="headTable">Трудоемкость (в академических часах)</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "work in structure">
            <td>{{structure.indexOf(work) + 1}}</td>
            <td><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.part"></textarea></div></td>
            <td><vue-editor v-model="work.content" :editor-toolbar="customContentToolbar"/></td>
            <td><div class="ui transparent input"><input style="width:100%;" type="text" placeholder="Часов" v-model="work.time"></div></td>
            <td width="2%">
              <button class="ui icon button red stub" v-on:click="DelStructure(structure.indexOf(work))"><i class="trash icon"></i></button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">Итого</td>
            <td colspan="2">{{needTime}} ({{main_info.load.hour}})</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="5">
              <button class="ui right floated small button positive" v-on:click="AddStructure">
                <i class="add icon"></i>
                Добавить раздел
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <h3 class="ui dividing header">8. ОБРАЗОВАТЕЛЬНЫЕ, НАУЧНО-ИССЛЕДОВАТЕЛЬСКИЕ И НАУЧНО-ПРОИЗВОДСТВЕННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ НА ПРАКТИКЕ</h3>
        <vue-editor v-model="text_info.technology" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">9. ФОРМА ОТЧЕТНОСТИ ПО ПРАКТИКЕ</h3>
        <vue-editor v-model="text_info.report_text" :editor-toolbar="customToolbar"/>
        <div v-if="main_info.speciality_code.length !== 6 && main_info.speciality_code.length !== 7">
          <h3 class="ui dividing header">10. ОЦЕНОЧНЫЕ СРЕДСТВА ДЛЯ ПРОВЕДЕНИЯ ПРОМЕЖУТОЧНОЙ АТТЕСТАЦИИ ПО ПРАКТИКЕ</h3>
          <vue-editor v-model="text_info.eval_tool" :editor-toolbar="customToolbar"/>
        </div>
        <h3 class="ui dividing header">11. УЧЕБНО-МЕТОДИЧЕСКИЕ МАТЕРИАЛЫ ПО ПРАКТИКЕ</h3>
        <div>
          <h4>11.1. Литература</h4>
          <vue-editor v-model="text_info.literature" :editor-toolbar="customToolbar"/>
          <h4>11.2. Программное обеспечение и Интернет-ресурсы</h4>
          <h4>Программное обеспечение</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                <select id="software" class="ui fluid search selection dropdown"
                        name="software"
                        v-model="soft.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in select_options.software" :value="option" :key="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                    {{ soft.info.name }}
                </div>
              </td>
              <td>
                {{ soft.info.license }}
              </td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelSoftware(software.indexOf(soft))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddSoftware">
                  <i class="add icon"></i>
                  Добавить программное обеспечение
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>Интернет ресурсы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "res in resources">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="res.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="res.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelResources(resources.indexOf(res))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddResources">
                  <i class="add icon"></i>
                  Добавить Интернет ресурс
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>11.3. Профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="db.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="db.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDataBases(data_bases.indexOf(db))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDataBases">
                  <i class="add icon"></i>
                  Добавить справочную систему
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
        <h3 class="ui dividing header">12. ИНФОРМАЦИОННЫЕ ТЕХНОЛОГИИ, ИСПОЛЬЗУЕМЫЕ ДЛЯ ПРОВЕДЕНИЯ  ПРАКТИКИ</h3>
        <vue-editor v-model="text_info.inform_tech" :editor-toolbar="customToolbar"/>
        <h3 class="ui dividing header">13. МАТЕРИАЛЬНО-ТЕХНИЧЕСКОЕ ОБЕСПЕЧЕНИЕ  ПРАКТИКИ </h3>
        <vue-editor v-model="text_info.mto" :editor-toolbar="customToolbar"/>
      </div>
      <div class="ui bottom large attached button positive" tabindex="0" v-on:click="PushToController">
        Сохранить
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from "vue2-editor";
import competitionsMixin from "../mixins/competitionsMixin";
import dataMixin from "../mixins/dataMixin";
import dataRppMixin from "../mixins/dataRppMixin";
import computedMixin from "../mixins/computedMixin";
import getersMixin from "../mixins/getersMixin";
import tableOperationMixin from "../mixins/tableOperationMixin";
import _ from "lodash";

export default {
  name: "create_rpp",
  mixins: [competitionsMixin, dataMixin, dataRppMixin, computedMixin, getersMixin, tableOperationMixin],
  components: { VueEditor },
  methods: {
    getMainInformation(edu_prog_id, edu_prof_id, curriculum_id, discipline_id) {
      if (discipline_id !== ""){
        axios({
          method: 'get',
          url: `/programms/get_main_info/${edu_prog_id}/${edu_prof_id}/${curriculum_id}/${discipline_id}`,
        }).then((response) => {
          this.main_info.discipline = response.data.discipline;
          this.main_info.speciality = response.data.speciality;
          this.main_info.speciality_code = response.data.speciality_code;
          if (this.no_profile.includes(edu_prog_id)) {
            this.main_info.profile = "";
          }
          else{
            this.main_info.profile = response.data.profile;
          }
          this.main_info.quality = this.basis_info[response.data.speciality_code].quality;
          this.main_info.year = response.data.year;
          this.main_info.edu_form = response.data.edu_form;
          this.overload = response.data.overload;
          this.main_info.creator.fio = response.data.fio;
          this.main_info.creator.position = response.data.position;
          this.main_info.creator.title = response.data.title;
          this.main_info.facility = response.data.facility;
          this.main_info.department = response.data.department;
          this.main_info.dep_manager = response.data.dep_manager;
          this.main_info.basis_num = this.basis_info[response.data.speciality_code].basis_num;
          this.main_info.basis_date = this.basis_info[response.data.speciality_code].basis_date;
          this.getControl();
          this.main = true;
          this.basisText()
          this.aproval();
        }).catch((error) => {
          return error;
        });
      }
    },
    basisText(){
      if (this.main_info.speciality_code.split('.')[1] === '05'){
        this.main_info.basis = "Программа практики составлена на основании Федерального государственного образовательного стандарта высшего образования по специальности " + this.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
      }
      else if (this.main_info.speciality_code.split('.')[1] === '02'){
          this.main_info.basis = "Программа практики составлена на основании Федерального государственного образовательного стандарта среднего профессионального образования по специальности " + this.main_info.speciality + ", утвержденного приказом " + this.ministry[0]
      }
      else {
        this.main_info.basis = "Программа практики составлена на основании Федерального государственного образовательного стандарта высшего образования по направления подготовки " + this.main_info.speciality + ", утвержденного приказом " + this.ministry[0]
      }
    },
    getRPP(id) {
      if (id == 0 ){
        this.text_info = {purpose: "", time: "", place: "", technology: "", eval_tool: "", literature: "", mto: "", size: "", report_text: "", inform_tech: ""};
        this.software = [];
        this.resources = [];
        this.data_bases = [];
        this.structure = [{
          part: "",
          content: "",
          time: 0,
        }];
        this.practice_type = {type: "", method: ""};
      }
      else {
        axios({
          method: 'get',
          url: `/programms/get_rpp/${id}`,
        }).then((response) => {
          this.text_info.purpose = response.data.rpp.purpose_old;
          this.text_info.time = response.data.rpp.practice_time_old;
          this.text_info.place = response.data.rpp.practice_place_old;
          this.text_info.technology = response.data.rpp.edu_tech_old;
          this.text_info.eval_tool = response.data.rpp.eval_tool_old;
          this.text_info.literature = response.data.rpp.literature_old;
          this.text_info.report_text = response.data.rpp.report_text_old;
          this.text_info.size = response.data.rpp.practice_size_old;
          this.text_info.inform_tech = response.data.rpp.inform_tech_old;
          this.text_info.mto = response.data.rpp.structure_text_old;
          this.resources = response.data.rpp.resources;
          this.data_bases = response.data.rpp.data_bases;
          this.structure = response.data.rpp.structure;
          this.practice_type = response.data.rpp.practice_type;
        }).catch((error) => {
          return error;
        });
      }
    },
    getRPPSamples(){
      axios({
        method: 'get',
        url: `/programms/get_rpp_samples`,
      }).then((response) => {
        this.select_options.rpp_samples = response.data.samples
      }).catch((error) => {
        return error;
      });
    },
    PushToController (){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'post',
        url: '/programms/rpp',
        data: {
          data: {
            curriculum_id: this.rpp.curriculum,
            discipline_id: this.rpp.discipline,
            study_year_id: this.rpp.year,
            educational_profile_id: this.rpp.edu_prof,
            educational_programm_id: this.rpp.edu_prog,
            name: this.main_info.discipline,
            purpose_old: this.text_info.purpose,
            report_text_old: this.text_info.report_text,
            tasks_old: this.text_info.task,
            practice_place_old: this.text_info.place,
            structure_text_old: this.text_info.mto,
            edu_tech_old: this.text_info.technology,
            eval_tool_old: this.text_info.eval_tool,
            literature_old: this.text_info.literature,
            practice_time_old: this.text_info.time,
            practice_size_old: this.text_info.size,
            inform_tech_old: this.text_info.inform_tech,
            competition: this.rpp_competitions,
            software: this.software,
            resources: this.resources,
            data_bases: this.data_bases,
            structure: this.structure,
            main_info: this.main_info,
            practice_type: this.practice_type,
          }
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204){
          location.assign('/programms/rpd')
        }
      }).catch((error) => {
        return error;
      });
    },
  },

  mounted() {
    this.getEduProg()
    this.getYears()
    this.getSoftware()
    this.getRPPSamples()
  }
}
</script>

<style scoped>
  .vueditor {
    width: 100px;
    height: 450px;
    height: 100%;
    border: 1px solid #ddd;
    background: #fff;
    box-sizing: border-box;
    position: relative;
  }

  .verticalText
  {
    text-align: center;
    vertical-align: middle;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    line-height: 1;
    width: 20px;
  }

  .headTable
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
  }

  .headTableInt
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
    word-wrap: break-word;
    width: 70px;
  }
</style>